import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useDialogStyles } from "../styles/dialogStyles";
import { TFunction } from "react-i18next";

interface ProgressSectionProps {
    currentStage: number;
    totalStages: number;
    progressPercentage: number;
    t: TFunction;
}

export function ProgressSection({
    progressPercentage,
    t
}: ProgressSectionProps) {
    const classes = useDialogStyles();

    return (
        <div className={classes.progressSection}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
            >
                <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {t("overallProgress")}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {progressPercentage}%
                </Typography>
            </Box>
            <div className={classes.progressBar}>
                <div
                    className={classes.progressFill}
                    style={{ width: `${progressPercentage}%` }}
                />
            </div>
        </div>
    );
}
